<template>
  <div>
    <span class="body-2 font-weight-medium">Let's get started!</span>

    <v-row no-gutters class="mt-2">
      <span class="body-2">Search for your Town, Parish or Community Council.</span>
    </v-row>

    <parish-search class="mt-4"></parish-search>

    <div v-if="!PARISH" style="height: 48px">

    </div>
    <div v-if="PARISH">
      <v-row no-gutters class="mt-4">
          <span class="body-2">You've selected
            <span class="body-2 font-weight-medium">{{ PARISH.organisation_title }}</span>.
          </span>
      </v-row>
      <v-row no-gutters>
          <span class="body-2">Click "Next" to continue the signup process.</span>
      </v-row>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import ParishSearch from "@/components/ParishSearch";

  export default {
    name: "StepOne",
    components: {ParishSearch},
    props: {},
    data() {
      return {

      }
    },
    computed: {
      ...mapGetters({
        PARISH: 'GET_SELECTED_PARISH',
      }),
    },
    methods: {}
  }
</script>
